module.exports = __webpack_public_path__ + "img/generic.2ac11089.svg";